export function getBlankRecord() {
  return {
    id: null,
    type: null,
    frequencyUnit: null,
    frequency: null,
    due: null,
    lastRun: null,
    status: null,
    isSuspended: false
  };
}
